<template>
 <div class="wrap talk re-style">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification pass">
					<section class="txt">
						<h2>본인 인증</h2>
					</section>
          <section>
              <div class="img-group">
                <img src="@/assets/images/img-crtfPassNew.png" alt="">
                <div class="input">
                  <span class="typing-demo is-ani" style="text-align: left;">{{secKey1}}{{secKey2}}</span>
                </div>
              </div>
              <div class="box">
                <p>판매하려는 중고폰의 {{appText}} 화면에 <br>
                  <b>다음 번호 <span>{{secKey1}}{{secKey2}}</span>을(를) 입력해주세요</b>
                </p>
                <div class="num">
                 	<span>{{secKey1}}</span>
								  <span>{{secKey2}}</span>
                </div>
              </div>
            </section>
          <div class="btn-wrap">
            <button class="talk-btn btn-black" @click="closeWindow()">확인</button>
          </div>
				</article>
			</main>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'


export default {
  name: 'RandomNumApp',
  components: { 

   },
  data: () => ({
    AppConfig: AppConfig,
    
    secKey1:'0',
    secKey2:'0',    
	appText: '커넥터앱',
  }),
  computed: {

  },
  mounted() {

    this.secKey1 = (this.$route.query.rn).substring(0, 1);
    this.secKey2 = (this.$route.query.rn).substring(1, 2);
	if(this.$route.query.sysGbn == 'APP') {
		this.appText = '세이프앱'
	}
  },
  methods: {

    closeWindow() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('kakaotalk') > -1) {
        if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1) {
          window.location.href = 'kakaoweb://closeBrowser'
        } else {
          window.location.href = 'kakaotalk://inappbrowser/close'
        }
      } else if (window) {
        if (window.opener) {
          window.opener.close()
        }
        window.close()
      }
    }   

  }
}
</script>



// WEBPACK FOOTER //
// src/views/crtfpass/RandomNumApp.vue